<div class="login-page">
  <div class="hero-panel" aria-hidden="true">
    <div class="hero-copy">
      <p class="eyebrow">{{ 'login.eyebrow' | t }}</p>
      <h1>{{ appName }}</h1>
      <p>{{ 'login.hero' | t }}</p>
    </div>
  </div>

  <div class="form-panel">
    <div class="lang-top">
      <app-language-switcher />
    </div>

    <form class="login-card ct-card" [formGroup]="form" (ngSubmit)="submit()">
      <div class="logo">
        <img [src]="logoUrl" [alt]="appName" />
        <div>
          <strong>{{ appName }}</strong>
          <small>{{ 'login.signIn' | t }}</small>
        </div>
      </div>

      <div class="ct-field">
        <label for="email">{{ 'login.email' | t }}</label>
        <input id="email" class="ct-input" type="text" formControlName="email" autocomplete="username" />
      </div>

      <div class="ct-field">
        <label for="password">{{ 'login.password' | t }}</label>
        <input id="password" class="ct-input" type="password" formControlName="password" autocomplete="current-password" />
      </div>

      <a class="forgot-link" routerLink="/forgot-password">{{ 'passwordReset.forgotLink' | t }}</a>

      <button class="ct-btn ct-btn-navy login-btn" type="submit" [disabled]="submitting()">
        {{ 'login.submit' | t }}
      </button>
      @if (error()) {
        <p class="error">{{ 'login.error' | t }}</p>
      }
    </form>
  </div>
</div>
